const firebaseConfig = {
  apiKey: "AIzaSyCe7qa6pcT1Nir5h9V5ldFCN46nf4Ln5xs",
  authDomain: "hot-onion-restaurant-b3126.firebaseapp.com",
  databaseURL: "https://hot-onion-restaurant-b3126.firebaseio.com",
  projectId: "hot-onion-restaurant-b3126",
  storageBucket: "hot-onion-restaurant-b3126.appspot.com",
  messagingSenderId: "557079488183",
  appId: "1:557079488183:web:4ed6d12b954f15bb158f32"
};

export default firebaseConfig;